import React, {Component} from 'react';
import AdminTabs from './AdminTabs';
import {DataTable} from "react-data-components";
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';
import moment from 'moment';
import ReactTable from 'react-table';
import 'react-table/react-table.css'

class TimeToRespondCounter extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            counter: null,
            timerId: null,
            timerClass: ''
        }

        this.timer = null;
    }
    
    componentDidMount = (props) => {
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let counter = 0;
        if(responseTime){
            let now = moment();
            let responseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value), 'hours')._d);
            counter = moment.duration(responseBy.diff(now, 'seconds') * 1000);
            // moment().diff(responseBy, 'hours')
            
            this.setState({counter: counter}, () => {
                if (!this.timer) {
                    // Initiate lecture timer
                    this.timer = setInterval(this.updateTimer, 1000);
    
                }
            });
        }
        
    }

    componentWillUnmount(){
        clearInterval(this.timer);
    }
    
    updateTimer = () => {
        let {timerClass} = this.state;
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let halfResponseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value) / 2, 'hours')._d);
        let responseBy = moment(moment(this.props.row.createdAt).add(parseInt(responseTime.value), 'hours')._d);
        
        if(moment.duration(responseBy.diff(moment(), 'seconds') * 1000).asSeconds() < 0){
            timerClass = 'text-danger';
        }else if(moment.duration(halfResponseBy.diff(moment(), 'seconds') * 1000).asSeconds() < 0){
            timerClass = 'text-warning';
        }
            this.setState({counter: this.state.counter.subtract(1, 'seconds'), timerClass});
    }
    
    render(){
        let {counter, timerClass} = this.state;
        
        return (
            <span>{counter &&
                 <span className={timerClass}>{counter.days() + 'd ' + counter.hours() + 'h ' + counter.minutes() + 'm ' + counter.seconds() + 's'}</span>
            }
            </span>
            
        )
    }
}

class AdminTicketView extends Component {
    constructor(props){
        super(props);

        this.state = {
            search: ''
        }
    }

    renderSearchRow = () => {
        return (
            <div className="row">
                <div className="col-md-9"></div>
                <div className="col-md-3">
                    <div className="text-right">
                        <input 
                            className="form-control"
                            value={this.state.search}
                            onChange={e => this.setState({search: e.target.value})}
                            type="text"
                            placeholder="Search"
                        />
                        <br /><br />
                    </div>
                </div>

            </div>
        )
    }

    renderQuestion = (data) => {
        let avatar = userImage;
        const row = data.original;
        if(row.Profiles){
        if(row.Profiles[0]){
            if(row.Profiles[0].image){
                if(row.Profiles[0].image.indexOf('http') > -1){
                    avatar = row.Profiles[0].image;
                }else{
                    avatar = api.makeFileURL(row.Profiles[0].image, this.props.user.id);
                }
            }

            return (
                <div className="user-and-question" onClick={e => this.props.history.push('/chat/' + row.id)}>
                    <div className="uq-avatar-wrap">
                        <img src={avatar} />
                    </div>
                    <div>
                        <h3>{row.Profiles[0].name + ' ' + row.Profiles[0].lname}</h3>
                        <p className="task-desc-table">{row.question}</p>
                    </div>
                </div>
            )
        }else{
            return (
                <div className="user-and-question" onClick={e => this.props.history.push('/chat/' + row.id)}>
                    <div className="uq-avatar-wrap">
                        <img src={userImage} />
                    </div>
                    <div>
                        <h3>{'No Name'}</h3>
                        <p className="task-desc-table">{row.question}</p>
                    </div>
                </div>
            )
        }
    }else{
        return (
            <div className="user-and-question" onClick={e => this.props.history.push('/chat/' + row.id)}>
                <div className="uq-avatar-wrap">
                    <img src={userImage} />
                </div>
                <div>
                    <h3>{'No Name'}</h3>
                    <p className="task-desc-table">{row.question}</p>
                </div>
            </div>
        )
    }
        
    }
    
    renderResponses = (data) => {
        const row = data.original;
        if(row.responses){
            return (
                <span>{row.responses || 0}</span>
            )
        }else{
            return 0;
        }
    }
    
    renderCourse = (data) => {
        let course = null;
        const row = data.original;
        if(row.Subject){
            this.props.courses.map(c => {
                if(c.id === row.Subject.courseId){
                    course = c;
                }

            })
        }
        if(row.Subject){
            if(row.Subject.Course){
                return (
                    <span>{(row.Subject.Course) ? row.Subject.Course.name : ''}</span>
                )
            }
        }

        return null;
        
    }
    
    renderSubject = (data) => {
        let subject = null;
        const row = data.original;
        if(this.props.courses){
            this.props.courses.map(c => {
                if(c.CourseSubject){
                    c.CourseSubject.map(s => {
                        if(s.id === row.subjectId){
                            subject = s;
                        }
                    })
                }
            })
        }
        if(row.Subject){
            return (
                <span>{row.Subject.name}</span>
            )
        }else{
            return null;
        }
    }
    
    renderOpenedSince = (data) => {
        const row = data.original;
        return (
            <span>{moment(row.createdAt).fromNow()}</span>
        )
    }
    
    renderTimeToRespond = (data) => {
        const row = data.original;
        
        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
        let counter = 0;
        if(responseTime){
            let now = moment();
            let responseBy = moment(row.createdAt).add(responseTime.value, 'hours');
            counter = moment.duration(responseBy.diff(now, 'seconds') * 1000);
            // moment().diff(responseBy, 'hours')
        }
        
        if(!row.closed && !row.solved){
        return (
            <TimeToRespondCounter
                row={row}
                settings={this.props.settings}
            />
            
        )
            
        }else{
            return (
                <div>-</div>
                )
        }
        
    }
    
    renderStatus = (data) => {
        const row = data.original;
        if(row.closed){
            return (
                <span className='text-warning'>CLOSED</span>
            )
        }else{
            return (
                <span className={`${(row.solved) ? 'text-success' : 'text-info'}`}>{(row.solved) ? 'RESOLVED' : 'OPEN'}</span>
            )
        }
    }

    renderAdminHeader = () => {
        return (
            <div>
                {this.props.match.params.subjectId &&
                        this.props.courses.filter(c => c.id === this.props.match.params.subjectId).length ?
                        <div>

                                <h2 className="font-22 text-white font-300 sm-bottom30"><span>{this.props.courses.filter(c => c.id === this.props.match.params.subjectId)[0].name} Tickets</span></h2>
                            
                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.ticket && t.Subject).filter(t => t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.ticket && t.Subject).filter(t => t.subjectId && t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.ticket && t.Subject).filter(t => t.subjectId && !t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.ticket && t.Subject).filter(t => t.subjectId && t.closed && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                        
                        :
                        <div>

                               <h2 className="font-22 text-white font-300 sm-bottom30"><span>All Tickets</span></h2>

                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.subjectId && t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && !t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && t.closed && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                     }
            </div>
        )
    }

    renderInstructorHeader = () => {
        return (
            <div className="chat-head text-center">
                        <div className="flex flex-justify-content-space-between">
                {this.props.match.params.subjectId &&
                        this.props.courses.filter(c => c.id === this.props.match.params.subjectId).length ?
                        <div>

                                <h2 className="font-22 text-white font-300 sm-bottom30"><span>{this.props.courses.filter(c => c.id === this.props.match.params.subjectId)[0].name} Tickets</span></h2>
                            
                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.subjectId && t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && !t.solved && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && t.closed && t.Subject.courseId === this.props.match.params.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                        
                        :
                        <div>

                               <h2 className="font-22 text-white font-300 sm-bottom30"><span>All Tickets</span></h2>

                            <div className="stacks-history">
                                <div className="stack-history-item">
                                    <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.subjectId && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.subjectId && t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && !t.solved && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Dismissed</span><span className="text-orange">{this.props.threads.filter(t => t.subjectId && t.closed && t.ticket).length}</span>
                                </div>
                                <div className="stack-history-item">
                                    <span>Average Response Time</span><span className="text-info">{this.renderResponseTime()}</span>
                                </div>
                            </div>
                        </div>
                     }
                 </div>
            </div>
        )
    }
    
    
    renderResponseTime = () => {
        let dur = 0;
        if(this.props.threads.length > 0){
            let threads = [];
            
            if(this.props.match.params.subjectId){
                threads = this.props.threads.filter(t => t.subjectId && t.ticket && t.Subject.courseId === this.props.match.params.subjectId);
            }else{
            
                threads = this.props.threads.filter(t => t.subjectId && t.ticket);
            }
            threads.filter(t => t.firstResponse).map(t => {
                dur += t.firstResponse;
            })
        if(dur > 0 && threads.filter(t => t.firstResponse).length > 0){
          return (
            <div>
                {moment.duration((dur * 1000) / threads.filter(t => t.firstResponse).length).humanize()}
            </div>
            )
        }else{
            return (
                <div>
                    N/A
                </div>
                )
        }
    }
        
      
    }
    
    render(){
        let data = (this.props.match.params.subjectId) ? this.props.threads.filter(t => {
            if(t.Subject){
                if(t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket){
                    return true;
                }
            }
        }) : this.props.threads.filter(t => t.subjectId && t.ticket);

        if(this.state.search){
            data = data.filter(d => {
                if(d.Profiles){
                    if(d.Profiles[0]){
                        let name = '';
                        if(d.Profiles[0].name){
                            name = d.Profiles[0].name.toLowerCase();
                        } 
                        
                        if(d.Profiles[0].lname){
                            name = name + " " + d.Profiles[0].lname.toLowerCase();
                        }

                        let course = '';
                        let subject = '';
                        if(d.Subject){
                            subject = d.Subject.name.toLowerCase();

                            if(d.Subject.Course){
                                course = d.Subject.Course.name.toLowerCase();
                            }
                        }

                        if(name.indexOf(this.state.search.toLowerCase()) > -1){
                            return true;
                        }else if(course.indexOf(this.state.search.toLowerCase()) > -1){
                            return true;
                        }else if(subject.indexOf(this.state.search.toLowerCase()) > -1){
                            return true;
                        }else if(this.state.search.toLocaleLowerCase() === 'solved' && d.solved){
                            return true;
                        }else if(this.state.search.toLocaleLowerCase() === 'closed' && d.closed){
                            return true;
                        }else if(this.state.search.toLocaleLowerCase() === 'open' && !d.closed && !d.solved){
                            return true;
                        }else if(d.question.toLowerCase().indexOf(this.state.search) > -1){
                            return true;
                        }else{
                            return false;
                        }
                    }
                }
            })
        }
        return (
            <div className="chat-box">
                {this.props.adminMode ?
                    <AdminTabs view="tickets" />
                : this.renderInstructorHeader()}
                <div className="chat-contents-wrapper" style={this.props.adminMode ? {background: '#111', paddingBottom: '50px'} : {background: '#111', paddingBottom: '50px', paddingTop: '150px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                        {this.props.adminMode ?
                            this.renderAdminHeader()
                        :
                            null

                        }
                    

                        {this.renderSearchRow()}

                        <div className="tickets-table">
                            <ReactTable
                                data={data}
                                columns={[
                                            
                                    {Header: 'Question', id: "question", accessor: d => d.Profiles[0] ? d.Profiles[0].name : 'id', className: 'v-middle', Cell: this.renderQuestion},
                                    {Header: 'Responses', type: 'number', id: "responses", accessor: d => {
                                        return Number(d.responses);
                                    }, className: 'v-middle', Cell: this.renderResponses},
                                    {Header: 'Course', id: "course", accessor: d => d.Subject ? d.Subject.Course ? d.Subject.Course.name : 'id' : 'id', className: 'v-middle', Cell: this.renderCourse},
                                    {Header: 'Subject', id: "subject", accessor: d => d.Subject.id, className: 'v-middle', Cell: this.renderSubject},
                                    {Header: 'Opened Since', accessor: 'createdAt', className: 'v-middle', Cell: this.renderOpenedSince},
                                    {Header: 'Time to Respond', id:"ttr", accessor: row => {
                                        let responseTime = this.props.settings.filter(s => s.name === "responseTime")[0];
                                        let counter = 0;
                                        if(responseTime){
                                            let now = moment();
                                            let responseBy = moment(row.createdAt).add(responseTime.value, 'hours');
                                            counter = moment.duration(responseBy.diff(now, 'seconds') * 1000);
                                            // moment().diff(responseBy, 'hours')
                                        }
                                        if(!row.closed && !row.solved){
                                        return counter.as('seconds');
                                        }else{
                                            return 0;
                                        }
                                    }, className: 'v-middle', Cell: this.renderTimeToRespond},
                                    {Header: 'Status', id: 'status', accessor: row => {
                                        if(row.closed){
                                            return 'CLOSED';
                                        }else if(row.solved){
                                            return 'SOLVED';
                                        }else{
                                            return 'OPEN';
                                        }
                                    }, className: 'v-middle', Cell: this.renderStatus}
                                ]}
                                resolveData={data => data.map(row => row)}
                                className="table-striped"
                            />
                            {/*
                                    <DataTable
                                        keys="name"
                                        className="table-striped"
                                        columns={[
                                            
                                            {title: 'Question', prop: 'question', className: 'v-middle', render: this.renderQuestion},
                                            {title: 'Responses', prop: 'status', className: 'v-middle', render: this.renderResponses},
                                            {title: 'Course', prop: 'Subject', className: 'v-middle', render: this.renderCourse},
                                            {title: 'Subject', prop: 'Subject', className: 'v-middle', render: this.renderSubject},
                                            {title: 'Opened Since', prop: 'createdAt', className: 'v-middle', render: this.renderOpenedSince},
                                            {title: 'Time to Respond', className: 'v-middle', render: this.renderTimeToRespond},
                                            {title: 'Status', prop: 'status', className: 'v-middle', render: this.renderStatus}
                                        ]}
                                        onSort={(p, data) => {
                                            // console.log("Sorting", p, data);
                                            let threads = this.props.threads;

                                            if(p.prop === 'question'){
                                                if(this.props.match.params.subjectId){
                                                    threads = this.props.threads.filter(t => {
                                                        if(t.Subject){
                                                            if(t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket && t.Profiles[0]){
                                                                return true;
                                                            }
                                                        }
                                                    })
                                                }else{
                                                    threads = this.props.threads.filter(t => t.subjectId && t.ticket && t.Profiles[0]);
                                                }

                                                if(p.order === 'ascending'){
                                                    threads = threads.sort((a, b) => {
                                                        if(a.Profiles[0].name < b.Profiles[0].name) { return -1; }
                                                        if(a.Profiles[0].name > b.Profiles[0].name) { return 1; }
                                                        return 0;
                                                    })
                                                }else if(p.order === 'descending'){
                                                    threads = threads.sort((a, b) => {
                                                        if(a.Profiles[0].name > b.Profiles[0].name) { return -1; }
                                                        if(a.Profiles[0].name < b.Profiles[0].name) { return 1; }
                                                        return 0;
                                                    })
                                                }else {
                                                    threads = threads.sort((a, b) => {
                                                        if(a.lastActivity > b.lastActivity) { return -1; }
                                                        if(a.lastActivity < b.lastActivity) { return 1; }
                                                        return 0;
                                                    })
                                                }

                                            }

                                            return threads;
                                        }}
                                        initialData={(this.props.match.params.subjectId) ? this.props.threads.filter(t => {
                                            if(t.Subject){
                                                if(t.subjectId && t.Subject.courseId === this.props.match.params.subjectId && t.ticket){
                                                    return true;
                                                }
                                            }
                                        }) : this.props.threads.filter(t => t.subjectId && t.ticket)}
                                        useShowHideColumns={true}
                                        initialPageLength={10}
                                        initialSortBy={{ prop: 'lastActivity', order: 'descending' }}
                                        pageLengthOptions={[10, 25, 50, 100]}
                                    />
                                    */}
                                </div>
                                    
                    </div>
                </div>
            </div>
            )
    }
}

export default AdminTicketView;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminTicketView.js